import {Injectable} from '@angular/core';
import {GetDesignForUserInterface} from '@app/shared/services/inksoft/GetDesignForUser.interface';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '@env/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InksoftGetListService {

  nbOfDesign: number = null;
  keepChecking = false;
  private isThereNewDesign = new BehaviorSubject({newDesign: false, designId: null});
  inksoftUserId = localStorage.getItem('inksoftUserId');

  constructor(private http: HttpClient) {
  }

  refreshForNewDesign() {
    this.GetDesignForUser(this.inksoftUserId).then(async (result: any) => {
      const countDesign = result.Data.ResponseData.Data.length;
      if (this.nbOfDesign == null) {
        this.nbOfDesign = countDesign;
      }
      if (this.nbOfDesign !== countDesign) {
        this.isThereNewDesign.next({designId: result.Data.ResponseData.Data[countDesign - 1].DesignID, newDesign: true});
      }
      if (this.keepChecking) {
        await new Promise(resolve => {
          setTimeout(() => {
            resolve(true);
          }, 3000);
        });
        this.refreshForNewDesign();
      }
    });
  }

  getNewDesignId() {
    return this.isThereNewDesign.asObservable();
  }

  async keepCheckForNewDesign(action: boolean, ms: number) {
    if (!action) {
      this.nbOfDesign = null;
      this.isThereNewDesign.next({newDesign: false, designId: null});
    }
    this.keepChecking = action;
    await new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, 10000);
    });
    this.refreshForNewDesign();
  }

  GetDesignForUser(userId: string) {
    return new Promise((resolve, reject) => {
      fetch(environment.baseUrl + '/Product/GetListDesignFromInkSoftUserId?userId=' + userId).then((response) => {
        return response.json();
      })
        .then((myJson) => {
          resolve(myJson);
        });
    });
  }

}
